var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simplemde"},[(_vm.showPlaceholder)?_c('span',{staticClass:"empty-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_c('textarea',{ref:"textarea",staticClass:"book-editor md-editor"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }